/* Penalties "Download CSV": pure column map over row_view rows + an all-pages loader. */
import { collect_all_pages } from '../../../util_components/csv_export/collect_pages';
import { csv_file_name } from '../../../util_components/csv_export/to_csv';
import { is_group_kind, session_who } from '../shared/session_link';
import { list_view } from './adapters';
import { list_params } from './requests';
import { LIMITS } from './params';

const raw = (r) => r.row || {};
const money = (r) => raw(r).money || {};
const nullable = (v) => (v === null || v === undefined ? '' : v);

// Amounts are rupees deducted (positive), as the server stores them; the screen shows them with a minus.
export const PENALTY_CSV_COLUMNS = [
  { header: 'Penalty ID', key: 'uuid' },
  { header: 'Teacher', value: (r) => raw(r).teacher_name || '' },
  { header: 'Teacher UUID', key: 'teacher_uuid' },
  { header: 'Session date (IST)', value: (r) => raw(r).session_start_ist, kind: 'datetime' },
  { header: 'Session UUID', key: 'session_uuid' },
  // the 1-on-1 student; blank for a group class or workshop (its name is in Student / class)
  {
    header: 'Student',
    value: (r) => (is_group_kind(r.session_kind) ? '' : raw(r).student_name || '')
  },
  {
    header: 'Student / class',
    value: (r) => {
      const who = session_who(r.session_kind, r.session_label, raw(r).student_name);
      return who.name ? `${who.noun} ${who.name}` : '';
    }
  },
  { header: 'Penalty', key: 'type_text' },
  { header: 'Source', key: 'source_text' },
  { header: 'Base rate', value: (r) => raw(r).base_rate_used, kind: 'money' },
  { header: 'Pen %', value: (r) => (r.session_uuid ? raw(r).penalty_pct : ''), kind: 'number' },
  { header: 'Original', value: (r) => raw(r).original_amount, kind: 'money' },
  { header: 'Corrected', value: (r) => nullable(raw(r).corrected_amount), kind: 'money' },
  { header: 'Charged', value: (r) => money(r).charged, kind: 'money' },
  { header: 'Waived', value: (r) => money(r).waived, kind: 'money' },
  { header: 'Free Pass', value: (r) => money(r).pass, kind: 'money' },
  { header: 'Status', key: 'waiver_text' },
  { header: 'State', key: 'state_text' },
  { header: 'Month needs review', key: 'needs_review', kind: 'bool' },
  { header: 'Reason', key: 'reason_text' },
  { header: 'Note', key: 'note' },
  { header: 'Approved by', key: 'approved_by' },
  { header: 'Updated by', value: (r) => raw(r).updated_by_name || raw(r).updated_by || '' },
  { header: 'Updated at (IST)', value: (r) => raw(r).updated_at_ist, kind: 'datetime' }
];

export const penalty_csv_name = (pay_month) =>
  csv_file_name({ page: 'penalties', table: 'penalties', period: pay_month });

/*
 * Every row matching the current filters and sort. The list pages by after_id (default order) or
 * offset (a column sort); the cursor carries whichever the server returned.
 */
export const penalty_csv_loader = (fetch_list, pay_month, filters, sort) => () =>
  collect_all_pages((cursor) =>
    fetch_list(
      list_params(pay_month, { ...filters, sort }, cursor || {}, LIMITS.LIST_LIMIT_MAX)
    ).then((data) => {
      const v = list_view(data);
      let next = null;
      if (v.next_offset !== null) next = { offset: v.next_offset };
      else if (v.next_after_id !== null) next = { after_id: v.next_after_id };
      return { rows: v.rows, next };
    })
  );
